/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
import "phaser";
import { setAmmochosen, currentAmmochosen } from './storage'
import { SelfDestruction, Bar } from './../Entities/GlobalEntities'
import { Shield } from './../Entities/Shields'
import { CircularDoublyLinkedList } from "../cdl";
import { SoundManager } from "../ScenesHelpers/SoundManager"
import { SceneGlobales } from "../ScenesHelpers/SceneGlobales";
import { TextManager } from "./../ScenesHelpers/TextManager"
import { ShootFactor } from "../Entities/Shoots";
import {
    getAllTeams,
    getMyTeam
} from "../../../web3/SFM-TeamsUtils";
import {
    getTopScores,
    getMyAddress,
} from "../../../web3/SFM-ScoreBoardContract_Utils";

export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

export function MuteBtnCreate(scene, mutepathLink) {
    const mutepath = mutepathLink;
    const mute = document.createElement("div");
    mute.innerHTML = `<button type='submit' id='mute' class="muteBtn">
                            <img   id= "muteImag" src="${mutepath}" width="20px" height="20px" alt="buttonpng" border="0" />
                            </button>`;
    scene.add.dom(
        scene.game.config.width * 0.2,
        scene.game.config.height * 0.1,
        mute,
        "background-color: transparent; width: 200px; height: 0; font: 48px Arial"
    );
    scene.game.sound.mute = false;
    return mute
}

export function swapMute(scene, mutepathLink, mutedpathLink) {
    let mutebtn = document.getElementById("muteImag");
    let mutepath
    if (scene.game.sound.mute == false) {
        scene.game.sound.mute = true;
        mutepath = mutepathLink;
    } else {
        scene.game.sound.mute = false;
        mutepath = mutedpathLink;
    }

    mutebtn.src = mutepath
}


export function AddImageToScene(scene, key) {
    scene.add.image(
        scene.game.config.width / 2,
        scene.game.config.height / 2,
        key
    );
}
export function createAnimation(scene, key, frameWidth, repeat) {
    scene.anims.create({
        key: key,
        frames: scene.anims.generateFrameNumbers(key),
        frameWidth: frameWidth,
        repeat: repeat,
    });
}

export function destroyOutOfScene(scene, entities) {
    const BOUNDRIES = {
        DistacneOutOFUpBoundries: 4,
        DistacneOutOFDownBoundries: 200
    }
    entities.getChildren().forEach((entity) => {
        entity.update();
        if (
            entity.x < -entity.displayWidth ||
            entity.x > scene.game.config.width + entity.displayWidth ||
            entity.y < -entity.displayHeight * BOUNDRIES.DistacneOutOFUpBoundries ||
            entity.y > scene.game.config.height - BOUNDRIES.DistacneOutOFDownBoundries + entity.displayHeight
        ) {
            if (entity) {
                if (entity.onDestroy !== undefined) {
                    entity.onDestroy();
                }
            }
        }
    });
}
export function consumeFuel(player, FuelBar) {
    player.consumeFuel();
    FuelBar.decrease(player.getfuel());
}
export function applyMove(scene, event, sfx) {
    const keyActions = {
        37: {
            action: () => {
                sfx.shipmoveleft.resume();
                scene.player.moveLeft();
            },
        },
        39: {
            action: () => {
                sfx.shipmoveright.resume();
                scene.player.moveRight();
            },
        },
        38: {
            action: () => {
                sfx.shipmoveup.resume();
                scene.player.moveUp();
            },
        },
        40: {
            action: () => {
                sfx.shipmovedown.resume();
                scene.player.moveDown();
            },
        },

    }
    const KeyCode = event.keyCode;
    event.preventDefault();
    const action = keyActions[KeyCode];

    if (action) {
        keyActions[KeyCode].action();
    }
    scene.firetail.firetailResume();
    scene.FuelBar.decrease(scene.player.getfuel());
}
export function applyUnMove(scene, event, sfx) {
    const keyActions = {
        37: {
            action: () => {
                sfx.shipmoveleft.pause();
                scene.player.moveLeftStop();
            },
        },
        39: {
            action: () => {
                sfx.shipmoveright.pause();
                scene.player.moveRightStop();
            },
        },
        38: {
            action: () => {
                sfx.shipmoveup.pause();
                scene.player.moveUpStop();
            },
        },
        40: {
            action: () => {
                sfx.shipmovedown.pause();
                scene.player.moveDownStop();
            },
        },

    }

    const KeyCode = event.keyCode
    const action = keyActions[KeyCode];

    if (action) {
        keyActions[KeyCode].action();
    }

    scene.firetail.firetailPause();
}
export function applyShoot(scene, weaponsData, player, weaponsfinished, shootchosen) {
    if (weaponsfinished < weaponsData.length) {
        const weapon = weaponsData[shootchosen];
        const { audio_key, name, level, scaleX, scaleY, anime_key, speedX, speedY, ammo_key } = weapon
        const shootAudioInner = SoundManager.createAudio(scene, audio_key, 0.5, false);
        const shootAudioOuter = { shootAudioInner };
        shootAudioInner.play();
        let shoot = new ShootFactor(
            scene,
            player.x,
            player.y,
            `${name}`,
            "shoot",
            level,
            scaleX,
            scaleY,
            anime_key,
            speedX,
            speedY,
            audio_key,
            player
        );
        shoot = shoot.create(scene, player.x, player.y, `${name}`, "shoot", level, scaleX, scaleY, anime_key, speedX, speedY, audio_key, player, weaponsData[shootchosen].class)
        shoot.applyShootAction()
        shoot.setData("shootkey", `${weaponsData[shootchosen].name}`);
        shoot.setData("shootlevel", weaponsData[shootchosen].level);
        scene.shoots.add(shoot);
        const ammoChosen = currentAmmochosen(ammo_key) - 1;
        setAmmochosen(ammoChosen, ammo_key);
        SceneGlobales.setCapacity(SceneGlobales.getCapacity() + 1)
        if (SceneGlobales.getCapacity() === 1) scene.lastShotTime = scene.time.now;
    }
    return shootchosen
}
export function applyShields(scene, shieldsData, player, shieldchosen) {
    if (scene.shields.getChildren().length == 0) {
        const shieldData = shieldsData[shieldchosen];
        const { audio_key, name, level, scaleX, scaleY, anime_key } = shieldData
        const shieldAudioInner = SoundManager.createAudio(scene, audio_key, 0.5, false);
        const shieldAudioOuter = { shieldAudioInner };
        shieldAudioInner.play();
        var shield = new Shield(
            scene,
            player.x,
            player.y,
            name,
            "shield",
            level,
            scaleX,
            scaleY,
            anime_key,
            audio_key
        );
        scene.shields.add(shield);
    }
    return shieldchosen


}
export function applyRepairekits(scene, repaireRand, repairekitObjectbar, shootObjectbar, shootChosen, weaponsData, weaponsFinished, specificammoText, highText, scoreText) {
    const textManager = new TextManager()
    if (repaireRand === "Supply_BB1 bar" && repairekitObjectbar[0].visible == true) {
        const y = 640
        const x = 60
        repairekitObjectbar[0].visible = false;
        shootObjectbar[shootChosen].alpha = 0.3;
        scene.shootdl = new CircularDoublyLinkedList();
        shootObjectbar = []
        weaponsData.forEach((weaponData, s) => {
            shootObjectbar[s] = new Bar(
                scene,
                x + s * x,
                y,
                weaponData.bar_key,
                "Bar",
                weaponData.bar_key
            );
            scene.shootdl.append(s);
            setAmmochosen(weaponData.ammo, `${weaponData.ammo_key}`);
            shootObjectbar[s].visible = true;
            shootObjectbar[s].alpha = 0.3;
            specificammoText[s].setTint(0xffffff);
            specificammoText[s].setText(weaponData.ammo);
        });
        shootObjectbar[shootChosen].alpha = 1;
        weaponsFinished = 0

    } else if (repaireRand === "Supply_BB2 bar" && repairekitObjectbar[0].visible == true) {
        repairekitObjectbar[0].visible = false;
        scene.player.setfuel(scene.playerData.maxFuel);
        scene.FuelBar.decrease(scene.player.getfuel());
        textManager.setTextOnScene(scene.fuelText, `Fuel Left: ${scene.player.getfuel()}`)
    } else {
        if (repairekitObjectbar[0].visible == true) {
            repairekitObjectbar[0].visible = false;
            scene.player.setCurrentPlayerScore(scene.player.getCurrentPlayerScore() * 2);

            if (scene.player.getCurrentPlayerScore() > parseInt(scene.player.getPlayerHighScore(), 10)) {
                scene.player.setPlayerHighScore(scene.player.getCurrentPlayerScore());
            }

            textManager.setTextOnScene(highText, `Highest: ${scene.player.getPlayerHighScore()}`)
            textManager.setTextOnScene(scoreText, `Score: ${scene.player.getCurrentPlayerScore()}`)
        }

    }
    const repairekitAudioInner = SoundManager.createAudio(scene, `${scene.repairekitsData[0].audio_key}`, 0.5, false);
    const repairekitAudioOuter = { repairekitAudioInner };
    repairekitAudioInner.play();
    return [repairekitObjectbar, shootObjectbar, shootChosen, weaponsData, weaponsFinished]
}
export function applySelfDestruction(scene, activate, player, score, mode) {
    const selfDestructionAudioInner = SoundManager.createAudio(scene, "selfDestructionwav", 0.5, false);
    scene.selfDestructionAudioOuter = { selfDestructionAudioInner };
    selfDestructionAudioInner.play();
    if (activate) {
        activate = false;
        selfDestructionAudioInner.pause();
        clearTimeout(scene.selfDestructionTimeout);
    } else {
        activate = true;
        selfDestructionAudioInner.play();
        const speedY = -200;

        scene.selfDestructionTimeout = setTimeout(() => {
            const selfdestruction = new SelfDestruction(
                scene,
                player.x,
                player.y,
                `self destruction`,
                "self destruction",
                1,
                1,
                null,
                0, speedY,
                "selfDestructionwav",
                player,
                mode
            );
        }, 2000);
        
    }                    
    return activate
}

export function swapShieldsLeft(scene, shieldObjectbar, shieldChosen) {
    shieldObjectbar[shieldChosen].alpha = 0.3;
    scene.shieldTraversed = scene.shielddl.traverseToIndexminus(shieldChosen - 1);
    shieldChosen = scene.shieldTraversed.value;
    shieldObjectbar[shieldChosen].alpha = 1;
    scene.squrebar2.x = shieldObjectbar[shieldChosen].x;
    scene.sfx.swap2.play();
    return [shieldObjectbar, shieldChosen]

}
export function swapShieldsRight(scene, shieldObjectbar, shieldChosen) {
    shieldObjectbar[shieldChosen].alpha = 0.3;
    scene.shieldTraversed = scene.shielddl.traverseToIndex(shieldChosen + 1);
    shieldChosen = scene.shieldTraversed.value;
    shieldObjectbar[shieldChosen].alpha = 1;
    scene.squrebar2.x = shieldObjectbar[shieldChosen].x;
    scene.sfx.swap2.play();
    return [shieldObjectbar, shieldChosen]

}
export function swapWeaponsLeft(scene, shootObjectbar, shootChosen) {
    shootObjectbar[shootChosen].alpha = 0.3;
    scene.shootTraversed = scene.shootdl.prevNODE(shootChosen);
    shootChosen = scene.shootTraversed.value;
    shootObjectbar[shootChosen].alpha = 1;
    scene.ammoText.setText(`${scene.weaponsData[shootChosen].name}: ${currentAmmochosen( scene.weaponsData[shootChosen].ammo_key)}`);
    scene.squrebar.x = shootObjectbar[shootChosen].x;
    scene.sfx.swap.play();
    return [shootObjectbar, shootChosen]

}
export function swapWeaponsRight(scene, shootObjectbar, shootChosen) {
    shootObjectbar[shootChosen].alpha = 0.3;
    scene.shootTraversed = scene.shootdl.nextNODE(shootChosen);
    shootChosen = scene.shootTraversed.value;
    shootObjectbar[shootChosen].alpha = 1;
    scene.ammoText.setText(`${scene.weaponsData[shootChosen].name}: ${currentAmmochosen(scene.weaponsData[shootChosen].ammo_key)}`);
    scene.squrebar.x = shootObjectbar[shootChosen].x;
    scene.sfx.swap.play();
    return [shootObjectbar, shootChosen]

}
export function loadImage(scene, key, value) {
    scene.load.image(key, value);
}
export function loadSpritesheet(scene, key, value, frameWidth, frameHeight) {
    scene.load.spritesheet(key, value, {
        frameWidth: frameWidth,
        frameHeight: frameHeight,
    });
}
export function loadAudio(scene, key, value) {
    scene.load.audio(key, value);
}
export const processData = async(mode) => {
    let allTeams;
    let allScores;
    if (mode === "on") {
        try {
            allTeams = await getAllTeams();
            allTeams = allTeams.toSorted((a, b) => parseInt(a.score.toString()) - parseInt(b.score.toString()));
            allTeams = allTeams.toReversed();
            return allTeams;
        } catch(err) {
            console.log(`Error while getting teams: ${err}`);
        }
    } else if (mode === "off") {
        try {
            allScores = await getTopScores();
            return allScores;
        } catch(err) {
            console.log(`Error while getting individual socres: ${err}`);
        }
    }
}